import { render } from "./ShopCart.vue?vue&type=template&id=61cd907e&scoped=true&bindings={\"cart\":\"options\",\"openConfirmEmptyModal\":\"options\"}"
import script from "./ShopCart.vue?vue&type=script&lang=js"
export * from "./ShopCart.vue?vue&type=script&lang=js"

import "./ShopCart.vue?vue&type=style&index=0&id=61cd907e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61cd907e"

export default script